import React from 'react'
import {css} from '@emotion/core'
import styled from '@emotion/styled'

import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import Heading from '../../../designSystem/Heading'
import Text from '../../../designSystem/Text'
import AuthenticationButtons from '../../auth/AuthenticationButtons'
import ProfileLinks from '../ProfileLinks'

type PropsType = {
  /** Whether the user is authenticated */
  isAuthenticated: boolean
  /** Whether user data is still loading */
  isLoading: boolean
  /** Callback for Login click */
  onLogInClick: () => void
  /** Callback for Signup click */
  onSignUpClick: () => void
}

const UserSideMenuWrapper = styled('div')(
  ({theme}) => css`
    margin: 0 ${theme.layout.spacing.s500}px;
    border-bottom: 1px solid ${theme.colors.navMenuBorder};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `
)

const UserSideMenu = ({
  isAuthenticated,
  isLoading,
  onLogInClick,
  onSignUpClick
}: PropsType) => {
  return (
    !isLoading && (
      <UserSideMenuWrapper>
        {isAuthenticated ? (
          <ProfileLinks />
        ) : (
          <>
            <Heading
              appearance="title3"
              marginTopSize="s500"
              marginBottomSize="s300"
            >
              <FormattedMessageWrapper
                id="userWidget.login"
                defaultMessage="Sign in or create account"
              />
            </Heading>
            <Text appearance="small" marginBottomSize="s500">
              <FormattedMessageWrapper
                id="userWidget.memberDisclaimer"
                defaultMessage="Find lower prices and member-only deals"
              />
            </Text>
            <AuthenticationButtons
              size="lg"
              onSignUpClick={onSignUpClick}
              onLogInClick={onLogInClick}
            />
          </>
        )}
      </UserSideMenuWrapper>
    )
  )
}

export default UserSideMenu
